'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducer;

var _reduxActions = require('redux-actions');

var _immutable = require('immutable');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _immutable.Map();

var reducer = (_reducer = {}, _defineProperty(_reducer, _fileUploadsActionTypes.ATTACHMENT_ERROR, function (state, action) {
  var _action$payload = action.payload,
      error = _action$payload.error,
      threadId = _action$payload.threadId;


  return state.set(threadId, error);
}), _defineProperty(_reducer, _fileUploadsActionTypes.DISMISS_ATTACHMENTS_ERROR, function (state, action) {
  var threadId = action.payload.threadId;


  return state.delete(threadId);
}), _defineProperty(_reducer, _fileUploadsActionTypes.ATTACHMENT_UPLOAD_START, function (state, action) {
  var threadId = action.payload.threadId;


  return state.delete(threadId);
}), _defineProperty(_reducer, _fileUploadsActionTypes.REMOVE_ATTACHMENT, function (state, action) {
  var threadId = action.payload.threadId;


  return state.delete(threadId);
}), _reducer);

exports.default = (0, _reduxActions.handleActions)(reducer, initialState);
module.exports = exports['default'];